/**
 * String 노드 id → Module 트리 노드 목록 (Vuex 트리에 넣기 전 lazy 보관)
 */
import { insertModuleTreeNodeInSeqOrder } from './panelModuleSeqOrder.js';

/** @type {Map<string, object[]>} */
let moduleChildrenByStringId = new Map();

export function clearPanelTreeModuleChildrenIndex() {
  moduleChildrenByStringId = new Map();
}

export function setPanelTreeModuleChildrenIndex(entries) {
  moduleChildrenByStringId = entries instanceof Map ? entries : new Map(entries);
}

export function registerStringModuleChildren(stringNodeId, moduleNodes) {
  if (!stringNodeId) return;
  if (!moduleNodes?.length) {
    moduleChildrenByStringId.delete(stringNodeId);
    return;
  }
  moduleChildrenByStringId.set(stringNodeId, moduleNodes);
}

export function getPanelTreeModuleChildren(stringNodeId) {
  if (!stringNodeId) return [];
  return moduleChildrenByStringId.get(stringNodeId) || [];
}

export function hasLazyModuleChildren(stringNodeId) {
  return moduleChildrenByStringId.has(stringNodeId);
}

/** String lazy 인덱스에서 Module 노드 1건 제거 (다른 String의 동일 표시 번호는 유지) */
export function removeModuleFromStringLazyIndex(stringNodeId, moduleNodeId) {
  if (!stringNodeId || moduleNodeId == null) {
    return;
  }
  const nodes = moduleChildrenByStringId.get(stringNodeId);
  if (!nodes?.length) {
    return;
  }
  const target = String(moduleNodeId);
  const filtered = nodes.filter(node => String(node.id) !== target);
  if (filtered.length === nodes.length) {
    return;
  }
  registerStringModuleChildren(stringNodeId, filtered);
}

/** String lazy 인덱스에 Module 노드 추가 (표시 명칭 사전순) */
export function appendModuleToStringLazyIndex(stringNodeId, moduleNode) {
  if (!stringNodeId || !moduleNode) {
    return;
  }
  const existing = [...(moduleChildrenByStringId.get(stringNodeId) || [])];
  if (existing.some(node => String(node.id) === String(moduleNode.id))) {
    return;
  }
  insertModuleTreeNodeInSeqOrder(existing, moduleNode);
  registerStringModuleChildren(stringNodeId, existing);
}
